import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 6l-6 6l6 6v-12","key":"svg-0"}]]

const IconCaretLeft = createReactComponent('outline', 'caret-left', 'CaretLeft', __iconNode);

export default IconCaretLeft;